import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import {
  LoginAttempt,
  LoginAttemptFailed,
  EUserActions,
  LoginAttemptSuccess,
  MeRequest,
  MeRequestOK,
  MeRequestFailure,
  Logout,
  LoginOtpRequired,
} from "../actions/user";
import { switchMap, tap, catchError, delay } from "rxjs/operators";
import { Router } from "@angular/router";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ApiService } from "../../services/api/api.service";
import { NgIf } from "@angular/common";

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private apiService: ApiService,
    private http: HttpClient,
  ) {}

  @Effect()
  /**
   * This effect has enaugh portion of responsability
   * Do not add any :)
   */
  login$ = this.actions$.pipe(
    ofType<LoginAttempt>(EUserActions.LoginAttempt),
    switchMap((action) =>
      this.apiService.post("auth/token", action.payload).pipe(
        switchMap((response) => {
          const { data: { uuid = null } = {} } = response;

          return uuid
            ? of(
                new LoginOtpRequired({
                  identifier: uuid,
                  type: "AUTH_OTP",
                }),
              )
            : of(
                new LoginAttemptSuccess({
                  data: response,
                  me: null,
                  authenticated: true,
                  authenticating: true,
                  errors: [],
                }),
              );
        }),
        catchError((response: HttpErrorResponse) => {
          const {
            error: {
              errors: {
                message = "Unable to fetch error message from response",
              } = {},
            } = {},
          } = response;

          return of(
            new LoginAttemptFailed({
              data: null,
              me: null,
              authenticating: false,
              authenticated: false,
              errors: [message],
            }),
          );
        }),
      ),
    ),
  );

  /**
   * Discribe any side effect that is related to successful authentication
   */
  @Effect()
  LoginAttemptSuccess$ = this.actions$.pipe(
    ofType<LoginAttemptSuccess>(EUserActions.LoginAttemptSuccess),
    switchMap((response) => {
      localStorage.setItem("auth", JSON.stringify(response.payload.data));
      return of(new MeRequest(true));
    }),
  );

  /**
   * Describe any side effect that should occure if user authentication fails
   */
  @Effect({ dispatch: false })
  LoginAttemptFailure$ = this.actions$.pipe(
    ofType<LoginAttemptFailed>(EUserActions.LoginAttemptFailed),
    tap((data) => {
      localStorage.removeItem("auth");
      return of([]);
    }),
  );

  // logout
  @Effect()
  Logout$ = this.actions$.pipe(
    ofType<Logout>(EUserActions.Logout),
    switchMap((data) => {
      return of(
        new LoginAttemptFailed({
          data: null,
          me: null,
          authenticated: false,
          authenticating: false,
          errors: [],
        }),
      );
    }),
  );

  @Effect({ dispatch: false })
  $LoginOtpRequired = this.actions$.pipe(
    ofType<LoginOtpRequired>(EUserActions.LoginOtpRequired),
    tap((data) => {}),
  );

  @Effect()
  /**
   * This effect has enaugh portion of responsability
   * Do not add any :)
   */
  MeRequest$ = this.actions$.pipe(
    ofType<MeRequest>(EUserActions.MeRequest),
    switchMap((action) =>
      this.apiService.get("me").pipe(
        switchMap((response) => {
          return of(
            new MeRequestOK({
              me: response.data.user,
              authenticating: false,
              authenticated: true,
            }),
          );
        }),
        catchError((response: HttpErrorResponse) => {
          return of(new MeRequestFailure({ errors: ["Token Expired"] }));
        }),
      ),
    ),
  );

  @Effect({ dispatch: false })
  MeRequestOK$ = this.actions$.pipe(
    ofType<MeRequestOK>(EUserActions.MeRequestOK),
    tap((data) => {
      //
    }),
  );

  @Effect()
  MeRequestFailure$ = this.actions$.pipe(
    ofType<MeRequestFailure>(EUserActions.MeRequestFailure),
    switchMap((data) => {
      return of(
        new LoginAttemptFailed({
          data: null,
          me: null,
          authenticated: false,
          authenticating: false,
          errors: data.payload.errors,
        }),
      );
    }),
  );
}
